// extracted by mini-css-extract-plugin
export default {"list":"Status__list___cMPNF","status":"Status__status___1ujrP"};